jQuery(document).ready(function($){

	/** ------- REM: en cas de double menu active, garder le dernier active -------- **/
	let menu_active = $("#sub-menu .bande-verte > ul > .active");
	if (menu_active.length > 1){

		let menu_active_first = $("#sub-menu .bande-verte > ul > .active")[0];
		$(menu_active_first).removeClass("current-menu-item");
		$(menu_active_first).removeClass("active");
	}


	/** ------- Block: contenu-filtrable -------- **/
	$(".filtre-contenu-sel").on("change", function(){
		$(this).closest(".contenu-filtrable").find(".cf-content").removeClass("show");
		let cur = $(this).val();
		$("#" + cur).addClass("show");
	})
	/** ------- /Block: contenu-filtrable -------- **/

	/** ------- Block: block-accordeon -------- **/
	$(".block-accordeon .collapse.show").each(function(){
		$(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
	});

	// Toggle plus minus icon on show hide of collapse element
	$(".block-accordeon .collapse").on('show.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
	}).on('hide.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
	});
	/** ------- /Block: block-accordeon -------- **/

	/** ------- Block: calculez-vos-economies -------- **/

	/** ------- /Block: calculez-vos-economies -------- **/


	/** ------- Block: carousel-chaine-de-valeur -------- **/
	function init_chaine_de_valeur() {
	  var owl = $('.owl-carousel');
	  owl.owlCarousel({

	    margin: 10,
	    nav: true,
	        navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
	    dots: false,
	    loop: false,

	    responsive: {
	      0: {
	        items: 1,stagePadding: 55,
	      },
	      600: {
	        items: 1,stagePadding: 50,
	      },
	      1000: {
	        items:3,stagePadding: 50,
	      },
	      1800: {
	        items:4, stagePadding: 100,
	      }
	    }
	  })
	}

	init_chaine_de_valeur();
	/** ------- Block: /carousel-chaine-de-valeur -------- **/
});


/** ------- Block: Video YT -------- **/
function playVideoAndHideOverlay(overlay) {

	  // Get the youtube iframe with a 'data-src' attribute
	  var iframe = overlay.querySelector('iframe[data-src]');

	  // Get the 'data-src' value
	  var src = iframe.getAttribute('data-src');

	  // Set the 'data-src' value to the 'src' attribute
	  iframe.setAttribute('src', src);

	  // Hide the overlay
	  overlay.querySelector('.video-consent-overlay').style.display = 'none';
	}


	function setPositiveConsentStatusForVendor(vendorId) {

	  // Get all the vendor purposes
	  var purposes = Didomi.getVendorById(vendorId).purposeIds;

	  // Create a "transaction"...
	  var transaction = Didomi.openTransaction();

	  // ... enable the vendor
	  transaction.enableVendor(vendorId);

	  // ... and all his purposes
	  transaction.enablePurposes(...purposes);

	  // update the new status using "commit"
	  transaction.commit();

	}


	// Create the "didomiOnReady" listener
	window.didomiConfig = {
	  languages: {
		enabled: ['en', 'fr'], // List of languages that visitors can use (must be a subset of the languages that we support)
		default: 'fr' // Default language to use if the visitor uses a language that is not enabled
	  }
	};
	window.didomiOnReady = window.didomiOnReady || [];
	window.didomiOnReady.push(function (Didomi) {

	  // Subscribe to the vendor status : It triggers the listener each time the status is changed for this vendor.
	  Didomi.getObservableOnUserConsentStatusForVendor('c:youtube-FXqh6r3a')
	  .subscribe(function (consentStatus) {

	    // Check if the "consentStatus" is true (eg. the user agreed to the vendor & his purposes)
	    if (consentStatus === true) {

	      // Loop into all the ".youtube-container" (even if we only have one in the example)
	      document.querySelectorAll('.youtube-container').forEach(function(video) {

	        // call our play & hide function
	        playVideoAndHideOverlay(video);

	      })

	    }

	  })

	  // An event listener is attached to each button element
	  document.querySelectorAll('.video-consent-overlay-accept-button').forEach(function(button) {
	    button.addEventListener('click', function() {

	      // When the button is clicked, we call the setPositiveConsentStatusForVendor custom function to enable the vendor (Youtube) and all his purposes.
	      setPositiveConsentStatusForVendor('c:youtube-FXqh6r3a');

	    })
	  })

	});

/** ------- /Block: Video YT -------- **/

/** ------- vibox.min.js -------- **/
if("undefined"==typeof jQuery)throw new Error("Iframe-modal plugin requires jQuery");+function(o){"use strict";var i=o.fn.jquery.split(" ")[0].split(".");if(i[0]<2&&i[1]<9||1==i[0]&&9==i[1]&&i[2]<1||i[0]>3)throw new Error("Iframe-modal plugin requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),function(o){"use strict";function i(i,n){this.element=i,this.modal={},this.options=o.extend({},t,n),this.overlay=o('<div class="vibox-overlay">'),this.content=o('<div class="vibox-content">'),this.iframe=o('<iframe class="vibox-iframe" src="'+this.options.src+'"></iframe>'),this.close=o('<span class="vibox-close">&times;</span>'),this.content.css({padding:this.options.padding,"margin-top":this.options.margin,"background-color":this.options.paddingColor,borderRadius:0==this.options.padding?0:this.options.borderRadius,width:this.options.responsive?"100%":this.options.width,"max-width":this.options.responsive?this.options.width:"auto",height:this.options.responsive?o(window).height()-2*this.options.margin:this.options.height,"max-height":this.options.responsive?this.options.height:"auto"}),this.init()}var t={padding:0,paddingColor:"#ffffff",borderRadius:0,margin:35,responsive:!0,width:560,height:340,preload:!1,src:"",onClosed:o.noop,beforeClosed:o.noop,onOpened:o.noop,beforeOpened:o.noop};i.prototype.init=function(){1==this.options.preload?e(this,n(this)):e(this)};var n=function(i){i.content.append(i.close,i.iframe),i.overlay.append(i.content),i.modal=i.overlay,o("body").append(i.overlay)},e=function(i){i.element.click(function(){0==i.options.preload&&o.isEmptyObject(i.modal)&&n(i),i.options.beforeOpened(),s(i)}),i.content.click(function(o){o.stopPropagation()}),i.close.click(function(){return r(i)}),i.overlay.click(function(){return r(i)}),o(window).resize(function(){p(i)})},s=function(i){o("html").addClass("vibox-fixed-body"),i.overlay.fadeIn(i.options.onOpened())},r=function(i){i.options.beforeClosed(),i.overlay.fadeOut(i.options.onClosed,function(){o("html").removeClass("vibox-fixed-body")})},p=function(i){var t=o(window).height()-2*i.options.margin,n=t>i.options.height?i.options.height:t;i.content.css({height:i.options.responsive?n:i.options.height})};o.fn.vibox=function(o){return new i(this,o)}}(jQuery);
/** ------- /vibox.min.js -------- **/


jQuery(function($) {
	$('#secondary-menu .menu-item').each(function() {

		// Vérifier si l'élément n'a AUCUN enfant
		if ($(this).children().length === 0) {
			$(this).addClass('nochild');
		}

	});
});


/** ------- actionmenu -------- **/
jQuery(function($) {

	// Parent : .menu-item-has-children > a
	$('.actionmenu .menu-item-has-children > a').on('click', function(e) {
		e.preventDefault(); // empêche le lien parent

		let $li = $(this).parent();

		// Si déjà ouvert → fermer
		if ($li.hasClass('is-open')) {
			$li.removeClass('is-open');
			return;
		}

		// Ferme tous les autres ouverts
		$('.actionmenu .menu-item-has-children.is-open').removeClass('is-open');

		// Ouvre celui-ci
		$li.addClass('is-open');
	});

	// Fermer le dropdown si clic en dehors
	$(document).on('click', function(e) {
		if (!$(e.target).closest('.actionmenu').length) {
			$('.actionmenu .menu-item-has-children.is-open').removeClass('is-open');
		}
	});

});


jQuery(function($) {

	// Parent : .menu-item-has-children > a
	$('.actionmenu-mobile .menu-item-has-children > a').on('click', function(e) {
		e.preventDefault(); // empêche le lien parent

		let $li = $(this).parent();

		// Si déjà ouvert → fermer
		if ($li.hasClass('is-open')) {
			$li.removeClass('is-open');
			return;
		}

		// Ferme tous les autres ouverts
		$('.actionmenu-mobile .menu-item-has-children.is-open').removeClass('is-open');

		// Ouvre celui-ci
		$li.addClass('is-open');

	});

	// Fermer le dropdown si clic en dehors
	$(document).on('click', function(e) {
		if (!$(e.target).closest('.actionmenu-mobile').length) {
			$('.actionmenu-mobile .menu-item-has-children.is-open').removeClass('is-open');
		}
	});

	$('.navbar-toggler').click(function(){
		$('body').toggleClass("menu-mobile-open");
	});

});

/** ------- actionmenu -------- **/


/** ------- menu mobile keyboard -------- **/
jQuery(function($) {
	var toggle = document.querySelector('.navbar-toggler[aria-controls="navbarSupportedContent"]');
	var panel  = document.getElementById('navbarSupportedContent');
	if (!toggle || !panel) return;

	function isOpen() {
		return panel.classList.contains('show');
	}

	function closeMenu() {
		$(panel).collapse('hide');

		toggle.focus();
	}

	document.addEventListener('keydown', function (e) {
		if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) {
			e.preventDefault();
			closeMenu();
		}
	});
});
/** ------- menu mobile keyboard -------- **/


(function () {
	var skip = document.querySelector('.skip-link[href="#main-content"]');
	var main = document.getElementById('main-content');
	if (!skip || !main) return;

	skip.addEventListener('click', function () {
		setTimeout(function () {
			main.focus({ preventScroll: true });
		}, 0);
	});
})();
